import {Box, Col, Row} from 'components/Grid';
import {ProductDetailedTagGroups} from 'modules/products/components/ProductDetailedTagGroups';
import style from './style.module.scss';
import {ITagGroup} from 'modules/products/types';
import {FC} from 'react';

interface IProps {
    tagGroups?: ITagGroup[];
}

const ProductTagsBlock: FC<IProps> = ({tagGroups = []}) => {
    return (
        <Box className={style.boxWrapper} commonPaddingOnMobileTablet={true}>
            <Row>
                <Col>
                    <ProductDetailedTagGroups tagGroups={tagGroups} />
                </Col>
            </Row>
        </Box>
    );
};

export default ProductTagsBlock;
